import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DemographicsSinglePersona from './DemographicsSinglePersona';
import DemographicsDoubleComparisionPersona from './DemographicsDoubleComparisionPersona';
import DemographicTripleComparisionPersona from './DemographicTripleComparisionPersona';
import downloadIconDefault from '../../images/insight360/download-icon_default.png';
import { getsortByKeyBasedOnSelectedTab } from '../../util/Insight360Utils';
import indexIconwhite from '../../images/index-icon_white.png';
import percentIconWhite from '../../images/percent-icon_white.png';
import { INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME } from '../../constants';

const Demographics = props => (
  <div>
    {props.demographics !== undefined &&
      props.demographics.length > 0 && (
      <div className="card main-card">
        <div className="card-header header-card">Demographics
        <span className="section-sort-by-index-reach-btns">
                <button
                  className="section-sort-icon index"
                  title="Index"
                  style={{
                    background: getsortByKeyBasedOnSelectedTab(props.selectedTab,
                      props.sortByKey, props.pcSortByKey, 'index'),
                  }}
                  onClick={() => {
                    props.sectionSortingByIndexAndReach(INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME, 'index');
                  }}
                >
                  <img
                    className="profile-section-sort-icon"
                    src={indexIconwhite}
                  />
                </button>
                <button
                  className="section-sort-icon reach"
                  title="Reach"
                  style={{
                    background: getsortByKeyBasedOnSelectedTab(props.selectedTab,
                      props.sortByKey, props.pcSortByKey, 'pct'),
                  }}
                  onClick={() => {
                    props.sectionSortingByIndexAndReach(INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME, 'pct');
                  }}
                >
                   <img
                     className="profile-section-sort-icon"
                     src={percentIconWhite}
                   />
                </button>
              </span>
        </div>
        <div className="row expanded card-section" id="cardOutlook">
          <div className="large-12 medium-12 small-12 columns">
            {props.downloadFlag &&
              <div className="text-right">
                <button
                  type="button"
                  onClick={() =>
                    props.download(
                      'Demographics',
                      'Demographics',
                      'demographicsPersonaGrid',
                      'personaHeader',
                    )
                  }
                  className="export-icon-class"
                >
                  <img
                    alt=""
                    src={downloadIconDefault}
                  />
                </button>
              </div>
            }
            <div>&nbsp;</div>
          </div>
          <div id="demographicsPersonaGrid">
            {props.demographics !== undefined &&
              props.demographics.length === 1 && (
              <DemographicsSinglePersona
                demographics={props.demographics}
                selectedTab={props.selectedTab}
              />
              )}
            {props.demographics !== undefined &&
              props.demographics.length === 2 && (
              <DemographicsDoubleComparisionPersona
                demographics={props.demographics}
                selectedTab={props.selectedTab}
              />
              )}
            {props.demographics !== undefined &&
              props.demographics.length === 3 && (
              <DemographicTripleComparisionPersona
                demographics={props.demographics}
                selectedTab={props.selectedTab}
              />
              )}
          </div>
          {props.sourceDataInfo()}
        </div>
      </div>
    )}
  </div>
);

Demographics.propTypes = {
  demographics: PropTypes.arrayOf(PropTypes.object),
  filterOptions: PropTypes.shape({}),
  download: PropTypes.func,
  sourceDataInfo: PropTypes.func,
  selectedTab: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    sortByKey: state.insight360.sortByIndexAndReach.demographics,
    pcSortByKey: state.insight360.personaCreator.sortByIndexAndReach.demographics,
  };
}


export default connect(
  mapStateToProps,
  null,
  null,
)(Demographics);

// export default Demographics;
